import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; //localStorage
import home from "./home";

const persistConfig = {
	key: "home",
	storage,
};

const persistedHomeReducer = persistReducer(persistConfig, home);

const store = configureStore({
	reducer: {
		homeState: persistedHomeReducer,
	},
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					"persist/PERSIST",
					"persist/REHYDRATE",
					"persist/REGISTER",
				],
			},
		}),
});

export const persistor = persistStore(store);
export default store;
